import RequestAbstract from '../abstract';

export default class UrlCallbacks extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/url-callbacks';
    }

    async resetRetries(id) {
        return await this.loadWithAuth(`${this.link}/reset-retries/${id}`, {
            method: 'GET'
        });
    }
}
